import SuperAdminDashboard from "@/pages/superadmin/Dashboard";
import SuperAdminCompanyList from "@/pages/superadmin/CompanyList";
import SuperAdminTrials from "@/pages/superadmin/Trials";
import CompanyDetails from "@/pages/superadmin/CompanyDetails";
import PartnerList from "@/pages/superadmin/PartnerList";
import PartnerDetails from "@/pages/superadmin/PartnerDetails";
import Reports from "@/pages/superadmin/Reports";
import PartnerDetailsReport from "@/pages/superadmin/report/Tier2PartnerDetails";
import Tier1PartnerReports from "@/pages/superadmin/report/Tier1PartnerReports";
import Tier2PartnerReports from "@/pages/superadmin/report/Tier2PartnerReports";
import Company from "@/pages/partner/Company";
import CoursesPartner from "@/pages/superadmin/Courses";
import ManageCourse from "@/pages/superadmin/Managecourse";
import TestPartner from "@/pages/superadmin/TestPartner";
import PartnerCustomerReports from "@/pages/superadmin/report/PartnerCustomerReports";
import Packages from "@/pages/superadmin/Packages";
import ReleaseUpdates from "@/pages/superadmin/ReleaseUpdates";
import Contracts from "@/pages/superadmin/Contracts";
import CourseRollout from "@/pages/superadmin/CourseRollout";
import Renewals from "@/pages/superadmin/Renewals";
import Invoices from "@/pages/superadmin/Invoices";

const routes = [
  {
    path: "/super-admin/invoices",
    name: "Super Admin Invoices",
    component: Invoices,
    meta: {
      breadcrumb: [
        {
          text: "Invoices",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },
  {
    path: "/super-admin/renewals",
    name: "Super Admin Renewals",
    component: Renewals,
    meta: {
      breadcrumb: [
        {
          text: "Renewals",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },
  {
    path: "/super-admin/dashboard",
    name: "Super Admin Dashboard",
    component: SuperAdminDashboard
  },
  {
    path: "/super-admin/trials",
    name: "Super Admin Trials",
    component: SuperAdminTrials,
    meta: {
      breadcrumb: [{ text: "SuperAdmin", disabled: true }],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },
  {
    path: "/super-admin/companies",
    name: "Company List",
    component: SuperAdminCompanyList,
    meta: {
      breadcrumb: [
        {
          text: "SuperAdmin",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },
  {
    path: "/super-admin/company/:id",
    name: "Company Details",
    component: CompanyDetails,
    meta: {
      breadcrumb: [
        {
          text: "Super Admin",
          disabled: false,
          href: "/super-admin/companies"
        },
        {
          text: "Company Details",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },
  {
    path: "/super-admin/partners",
    name: "Partner Lists",
    component: PartnerList,
    meta: {
      breadcrumb: [
        {
          text: "Super Admin",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },
  {
    path: "/super-admin/partner/:id",
    name: "Super Admin Partner Details",
    component: PartnerDetails,
    meta: {
      breadcrumb: [
        {
          text: "Partner List",
          disabled: false,
          href: "/super-admin/partners"
        },
        {
          text: "Partner Details",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },
  {
    path: "/super-admin/reports",
    name: "Super Admin Reports",
    component: Reports,
    meta: {
      breadcrumb: [
        {
          text: "Partner List",
          disabled: false,
          href: "/super-admin/partners"
        },
        {
          text: "Partner Details",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },
  {
    path: "/super-admin/partner/reports/:id",
    name: "Partner Deatils Reports",
    component: PartnerDetailsReport,
    meta: {
      breadcrumb: [
        {
          text: "Partner List",
          disabled: false,
          href: "/super-admin/partners"
        },
        {
          text: "Reports",
          disabled: false,
          href: "/super-admin/reports"
        },
        {
          text: "Partner Reports",
          disabled: false,
          href: "/super-admin/reports/partner1"
        },
        {
          text: "Partner Details",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },
  {
    path: "/super-admin/reports/partner1",
    name: "Tier 1 Partner Reports",
    component: Tier1PartnerReports,
    meta: {
      breadcrumb: [
        {
          text: "Partner List",
          disabled: false,
          href: "/super-admin/partners"
        },
        {
          text: "Reports",
          disabled: false,
          href: "/super-admin/reports"
        },
        {
          text: "Partner Details",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },
  {
    path: "/super-admin/reports/partner2",
    name: "Super Admin Tier 2 Partner Reports",
    component: Tier2PartnerReports,
    meta: {
      breadcrumb: [
        {
          text: "Partner List",
          disabled: false,
          href: "/super-admin/partners"
        },
        {
          text: "Reports",
          disabled: false,
          href: "/super-admin/reports"
        },
        {
          text: "Partner Details",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },
  {
    path: "/super-admin/partners/company",
    name: "Partner Company Lists",
    component: Company,
    meta: {
      breadcrumb: [
        {
          text: "Super Admin",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },
  {
    path: "/super-admin/courses",
    name: "Super Admin Courses Partner",
    component: CoursesPartner,
    meta: {
      breadcrumb: [
        {
          text: "super Admin",
          disabled: false,
          href: "/super-admin/courses"
        },
        {
          text: "Course Details",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },
  
  {
    path: "/super-admin/partner/courses/:id",
    name: "Super Admin Single Courses Partner",
    component: ManageCourse,
    meta: {
      breadcrumb: [
        {
          text: "super Admin",
          disabled: false,
          href: "/super-admin/companies"
        },
        {
          text: "Course Details",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },
  {
    path: "/super-admin/partner/courses/test/:id",
    name: "Super Admin Manage Courses",
    component: TestPartner,
    meta: {
      breadcrumb: [
        {
          text: "Companies",
          disabled: false,
          href: "/super-admin/companies"
        },
        {
          text: "Courses",
          disabled: false,
          href: "/super-admin/courses"
        },
        {
          text: "Test Partner",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },
  {
    path: "/super-admin/reports/customer",
    name: "Super Admin Customer Reports",
    component: PartnerCustomerReports,
    meta: {
      breadcrumb: [
        {
          text: "Partner List",
          disabled: false,
          href: "/super-admin/partners"
        },
        {
          text: "Reports",
          disabled: false,
          href: "/super-admin/reports"
        },
        {
          text: "Partner Details",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },
  {
    path: "/super-admin/packages",
    name: "Packages",
    component: Packages,
    meta: {
      breadcrumb: [
        {
          text: "Package Details",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },
  {
    path: "/super-admin/contracts",
    name: "Super Admin Contracts",
    component: Contracts,
    meta: {
      breadcrumb: [
        {
          text: "Contracts",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },
  {
    path: "/super-admin/course-rollout",
    name: "Super Admin Course Rollout",
    component: CourseRollout,
    meta: {
      breadcrumb: [
        {
          text: "Course Rollout",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },
  {
    path: "/super-admin/release-notes",
    name: "ReleaseUpdates",
    component: ReleaseUpdates,
    meta: {
      breadcrumb: [
        {
          text: "Release Notes",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      superAdmin: true
    }
  },

];

export default routes;

/*
export default routes.map(route => {
  const meta = {
    public: false,
    onlyLoggedOut: false,
    superAdmin: true
  };
  return { ...route, meta };
});
*/
